import {
    Button,
    Card,
    Col,
    message,
    Row,
    Anchor,
    Form,
    Upload,
    Modal, Select, Switch
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { AutoComplete } from "antd";


import { uploadFile, openS3File } from "../../api/files";
import { apiDelete, parseJsonResponse } from "../../api/apiClient";
import { updateDataContent, locationSearch, setInitialUploadForms } from "../../utils/formUtils";
import { LoadingScreen } from "../ui/LoadingScreen";
import { SaveIcon } from "../ui/SaveIcon";
import { useParams } from "react-router-dom";
import { DeleteOutlined, ExportOutlined, UploadOutlined } from "@ant-design/icons";
import { useGutachtenPersist } from "../../hooks/useGutachtenPersist";
import { useGutachtenData } from "../../hooks/useGutachtenData";
import { RiDeleteBin5Fill } from "react-icons/ri";
import { useSwitch } from '../../pages/SwitchContext';
import TextArea from "antd/es/input/TextArea";
import GutachtenShell from "./GutachtenShell";
// import { Link } from "react-router-dom";
// import { HashLink as Link } from "react-router-hash-link";
const { Dragger } = Upload;
const { Option } = Select;


const MENU_LINKS = [
    { href: '#anl_bilder', title: 'Bilddokumentation' },
    { href: '#karte', title: 'Karte' },
    { href: '#flurkarte', title: 'Flurkarte' },
    { href: '#grundbuchauszug', title: 'Grundbuchauszug' },
    { href: '#bauplan', title: 'Bauplan' },
    { href: '#flaechen', title: 'Flächen' },
    { href: '#sonstige-anlagen', title: 'Sonstige Anlagen' },
];

/** Kategorien mit Upload + „Neuer Eintrag“-Button (Reihenfolge wie bisher) */
const ANLAGEN_CATEGORY_KEYS = [
    'ANL_Bilder',
    'Karte',
    'Flurkarte',
    'Grundbuchauszug',
    'Bauplan',
    'Flaechen',
    'SonstigeAnlagen',
];

const anlagenCategoryHasDraft = (forms, key) =>
    !!(forms[key] && Object.prototype.hasOwnProperty.call(forms[key], 'undefined'));


const FormContainer = () => {
    const [cards, setCards] = useState({});
    const [formFormular1] = Form.useForm();
    const { auftragID, gutachtenID, tab } = useParams();
    const [selectedOption, setSelectedOption] = useState(null);
    const { isSwitchOn } = useSwitch();
    const { saveIcon, saveIcon1, isLoading, setIsLoading, updateTrigger, setUpdateTrigger, updateGutachten } = useGutachtenPersist(gutachtenID);

    const [uploadForms, setUploadForms] = useState({});
    const [toggleStates, setToggleStates] = useState({});
    const currentFileChangedRef = useRef(null);
    const currentFileChangedIDRef = useRef(null);
    const currentFileChangedComponentRef = useRef(null);

    const uploadFormsRef = useRef(uploadForms);
    const cardsRef = useRef(cards);
    useEffect(() => {
        uploadFormsRef.current = uploadForms;
    }, [uploadForms]);
    useEffect(() => {
        cardsRef.current = cards;
    }, [cards]);

    const handleSelectChange = (value) => setSelectedOption(value);

    const { dataContentRef, initialValues, enumerationValues } = useGutachtenData(gutachtenID, {
        setIsLoading,
        updateTrigger,
        saveIcon,
        onLoad: (data) => {
            const prevForms = uploadFormsRef.current;
            const prevCards = cardsRef.current;

            const initialToggleStates = {};
            Object.keys(data.Anlagen).forEach(category => {
                if (Array.isArray(data.Anlagen[category])) {
                    data.Anlagen[category].forEach(entry => {
                        const toggleKey = `Anlagen__${category}__${entry.id}__PositionGutachtentext`;
                        initialToggleStates[toggleKey] = entry.PositionGutachtentext || false;
                    });
                }
            });
            setToggleStates(initialToggleStates);

            const forms = {};
            const mergedCards = { ...data.Anlagen };

            ANLAGEN_CATEGORY_KEYS.forEach((key) => {
                const serverList = Array.isArray(data.Anlagen[key]) ? [...data.Anlagen[key]] : [];
                const localList = Array.isArray(prevCards[key]) ? prevCards[key] : [];

                setInitialUploadForms(forms, data.Anlagen[key], key, false);

                const extras = Math.max(0, localList.length - serverList.length);
                if (extras > 0) {
                    for (let i = 0; i < extras; i++) {
                        serverList.push({});
                    }
                    const draftSlot =
                        prevForms[key]?.undefined ??
                        { file: '', visible: true };
                    forms[key] = { ...forms[key], undefined: { ...draftSlot } };
                }

                mergedCards[key] = serverList;
            });

            setCards(mergedCards);
            setUploadForms(forms);
        },
    });

    const addCard = (component, uploadForm = false) => {
        if (uploadForm) {
            setUploadForms((prev) => {
                const next = { ...prev };
                const bucket = { ...(next[component] || {}) };
                bucket.undefined = { file: '', visible: true };
                next[component] = bucket;
                return next;
            });
        }

        setCards((prev) => ({
            ...prev,
            [component]: [...(prev[component] || []), {}],
        }));
    };
    const deleteCard = (component, index, id) => {
        Modal.confirm({
            title: 'Komponente löschen',
            content: 'Möchten Sie diesen Anlage wirklich löschen?',
            onOk() {
                deleteCardConfirmed(component, index, id);
            },
            onCancel() {
                console.log('Löschung abgebrochen');
            },
        });
    };

    const deleteCardConfirmed = (component, index, id) => {
        const currentComponent = dataContentRef.current.Anlagen[component][index];
        for (const key in currentComponent) {
            if (currentComponent.hasOwnProperty(key)) {
               if(typeof currentComponent[key] == "object" && currentComponent[key] != null  && currentComponent[key].id){
                   handleRemoveAttachmentConfirmed("", currentComponent[key].id).then();
               }
            }
        }
        const updatedCardsComponent = [...(cards[component] || [])];
        updatedCardsComponent.splice(index, 1);
        setCards((prev) => ({ ...prev, [component]: updatedCardsComponent }));
        //console.log(dataContentRef.current.Anlagen);
        //console.log(dataContentRef.current.Anlagen[component]);
        updateDataContent(component, index, dataContentRef.current, "deleteComponent");
        updateGutachten(dataContentRef.current, false);
    };

    const customUploadFile = async (file) => {

        try {
            if (file) {
                const responseUF = await uploadFile(file, true, auftragID);
                let fileValue = {};
                if (Array.isArray(responseUF)) {
                    responseUF.forEach((item) => {
                        fileValue["url"] = item.hash + item.ext;
                        fileValue["id"] = item.id;
                        fileValue["name"] = item.name;
                    });
                }
                if (Object.keys(fileValue).length === 0) fileValue = "-";
                updateDataContent(currentFileChangedRef.current, fileValue, dataContentRef.current, "updateByID");
                updateGutachten(dataContentRef.current, true, false);
            }
        } catch (error) {
            console.error(error);
        }
    };

    /*function setInitialUploadForms(files,name){
        let file_container;
        updatedUploadForms[name] = {};
        for (const key in files) {
            if (files.hasOwnProperty(key)) {
                const file = files[key];
                for(const key_file in file){
                    if (file.hasOwnProperty(key_file)) {
                         const value = file[key_file];

                         if(typeof value === "object" && value !== null){
                             file_container = value;
                         }
                    }
                }
                updatedUploadForms[name][file.id] = {}
                if(file_container){
                    updatedUploadForms[name][file.id].file = file_container;
                    updatedUploadForms[name][file.id].visible = false;
                } else {
                    updatedUploadForms[name][file.id].file = "";
                    updatedUploadForms[name][file.id].visible = true;
                }
                file_container = undefined;
            }
        }

        setUploadForms(updatedUploadForms);

    }*/
    const handleRemoveAttachment = (dataContentEntry, file) => {
        Modal.confirm({
            title: 'Datei löschen',
            content: 'Möchten Sie die Datei wirklich löschen?',
            onOk() {
                handleRemoveAttachmentConfirmed(dataContentEntry, file);
            },
            onCancel() {
                console.log('Löschung abgebrochen');
            },
        });
    };

    async function handleRemoveAttachmentConfirmed(dataContentEntry, file) {
        try {
            const response = await apiDelete(`/helper/acl/upload/${file}`);

            if (response.ok) {
                await parseJsonResponse(response);

            } else {
                console.log(`Request failed with status ${response.status}`);
            }
        } catch (error) {
            return error;
        }
        if(dataContentEntry != ""){
            
            updateDataContent(dataContentEntry, "-", dataContentRef.current, "updateByID");
            updateGutachten(dataContentRef.current, true, false);
        }
    }

    const FileChanged = (name, id, component) => {
        currentFileChangedRef.current = name;
        currentFileChangedIDRef.current = id; //Für später (löschen)
        currentFileChangedComponentRef.current = component; // Keine Ahnungs obs gebraucht wird
    };
    useEffect(() => formFormular1.resetFields(), [initialValues]);
    return (
        <div className={`${isSwitchOn ? 'bg-black' : 'bg-white'} sm:p-[20px] p-[10px] rounded-[30px]`}>
            {isLoading && <LoadingScreen />}
            {saveIcon1 && <SaveIcon saveIcon={saveIcon} />}
            <h2 className={`${isSwitchOn ? 'text-white' : 'text-black'} font-bold text-16px  md:text-[28px] mb-[20px] generalText`}>Anlagen</h2>
            <div>
                {dataContentRef.current && initialValues && enumerationValues && ( // Bedingung überprüft, ob dataContentRef.current bereits vorhanden ist
                    <Form
                        form={formFormular1}
                        onBlur={(e) => {
                            // Hier wird das onBlur-Ereignis für das gesamte Formular abgefangen
                            if (e.target.type != "button") { //Not at addCard
                                
                                //const patternTeilnehmerArt = /^AllAng__Ortstermin__\d+__TeilnehmerArt$/;
                                const updateValue = e.target.type === "search"
                                    ? (setSelectedOption(null), selectedOption)
                                    : e.target.value;
                                const updateByIDArray = ["Anlagen__ANL_Bilder", "Karte", "Flurkarte", "Grundbuchauszug", "Bauplan", "Flaechen", "SonstigeAnlagen"];
                                const foundComponent = updateByIDArray.find(value => e.target.id.includes(value));
                                if (e.target.id && foundComponent) {
                                    updateDataContent(e.target.id, updateValue, dataContentRef.current, "updateByID");
                                } else {
                                    updateDataContent(e.target.id, updateValue, dataContentRef.current, "updateByIndex");
                                }
                                if (e.target.id.includes("undefined")) {
                                    updateGutachten(dataContentRef.current, true, false);
                                } else {
                                    updateGutachten(dataContentRef.current, false);
                                }
                            }
                        }}
                        initialValues={initialValues}
                        labelCol={{ span: 8 }}
                        wrapperCol={{ span: 16 }}
                        layout="horizontal"
                    // style={{ maxWidth: 800 }}
                    >
                        <div id="anl_bilder" className="scrollable-section ">
                            <div
                                className="flex justify-between items-center p-[10px]  md:p-[20px] pr-[3%] md:pr-[10%]">
                                <h3 className={`font-bold text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Bilddokumentation</h3>

                            </div>

                            {cards?.ANL_Bilder?.map((entry, index) => (
                                <Card className={`pl-[3%] md:pl-[10%] ${isSwitchOn ? 'bgdark' : 'bgwhite'}`}
                                      size="small" key={index}>
                                    <div className={`flex   anlagen ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Form.Item label={`Kategorie:`}
                                                   name={`Anlagen__ANL_Bilder__${entry.id}__Bild_KategorieV`}>
                                            <AutoComplete
                                                className={"AutoCompleteTextArea AutoCompleteTextAreaSmall"}
                                                options={enumerationValues?.sub_com_Bild_Kategorie?.map(
                                                    (option, index) => ({value: option, key: index})
                                                )}
                                                filterOption={(inputValue, option) =>
                                                    option.value
                                                        .toUpperCase()
                                                        .indexOf(inputValue.toUpperCase()) !== -1
                                                }
                                                onChange={handleSelectChange} // Add your change handler if needed
                                            >
                                                <TextArea
                                                    placeholder="Kategorie"
                                                    autoSize={true}
                                                    className="textInput"
                                                />
                                            </AutoComplete>

                                        </Form.Item>
                                        <div className="ml-[10px] gap-[10px] flex">
                                            <div className=" ml-0  md:mt-[0]" style={{cursor: 'pointer'}}
                                                 onClick={() => deleteCard("ANL_Bilder", index, entry.id)}>
                                                <RiDeleteBin5Fill className="text-[#FF2E3B] w-[18px] h-[20px]"/>
                                            </div>
                                        </div>
                                    </div>


                                    <Form.Item label="Bild" name={`Anlagen__ANL_Bilder__${entry.id}__Bild`}
                                               className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        {uploadForms["ANL_Bilder"][entry.id] && uploadForms["ANL_Bilder"][entry.id].visible ? (
                                            <Upload.Dragger customRequest={customUploadFile}
                                                            onChange={(info) => FileChanged(`Anlagen__ANL_Bilder__${entry.id}__Bild`, entry.id, "ANL_Bilder")}
                                                            accept="image/jpg,image/jpeg,image/png">
                                                <p className="ant-upload-drag-icon">
                                                    <UploadOutlined/>
                                                </p>
                                                <p className="ant-upload-text">Klicke oder ziehe Dateien hierhin, um sie
                                                    hochzuladen</p>
                                                <p className="ant-upload-hint">Unterstützte Dateiformate: .jpg, .png</p>
                                            </Upload.Dragger>
                                        ) : uploadForms["ANL_Bilder"][entry.id] !== undefined ? (
                                            <>
                                                <div>
                                                    <Button icon={<ExportOutlined/>}
                                                            onClick={() => openS3File(uploadForms["ANL_Bilder"][entry.id].file.url)}>{uploadForms["ANL_Bilder"][entry.id].file.name}</Button>
                                                    <Button icon={<DeleteOutlined/>}
                                                            onClick={() => handleRemoveAttachment(`Anlagen__ANL_Bilder__${entry.id}__Bild`, uploadForms["ANL_Bilder"][entry.id].file.id)}>
                                                        Löschen
                                                    </Button>
                                                </div>
                                            </>
                                        ) : null}
                                    </Form.Item>
                                    <div className={`allgemeineClass1 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Form.Item label={`Lage:`}
                                                   name={`Anlagen__ANL_Bilder__${entry.id}__Bild_LageV`}>
                                            <AutoComplete
                                                className={"AutoCompleteTextArea"}
                                                options={enumerationValues.sub_com_Bild_Lage?.map(
                                                    (option, index) => ({value: option, key: index})
                                                )}
                                                filterOption={(inputValue, option) =>
                                                    option.value
                                                        .toUpperCase()
                                                        .indexOf(inputValue.toUpperCase()) !== -1
                                                }
                                                onChange={handleSelectChange} // Add your change handler if needed
                                            >
                                                <TextArea
                                                    placeholder="Lage"
                                                    autoSize={true}
                                                    className="textInput"
                                                />
                                            </AutoComplete>

                                        </Form.Item>
                                        <Form.Item label={`Anmerkungen:`}
                                                   name={`Anlagen__ANL_Bilder__${entry.id}__Bild_AnmerkungenV`}>
                                            <AutoComplete
                                                className={"AutoCompleteTextArea"}
                                                options={enumerationValues.sub_com_Bild_Anmerkungen?.map(
                                                    (option, index) => ({value: option, key: index})
                                                )}
                                                filterOption={(inputValue, option) =>
                                                    option.value
                                                        .toUpperCase()
                                                        .indexOf(inputValue.toUpperCase()) !== -1
                                                }
                                                onChange={handleSelectChange} // Add your change handler if needed
                                            >
                                                <TextArea
                                                    placeholder="Anmerkungen"
                                                    autoSize={true}
                                                    className="textInput"
                                                />
                                            </AutoComplete>

                                        </Form.Item>
                                            <Form.Item label={"Position:"} name={`Anlagen__ANL_Bilder__${entry.id}__PositionGutachtentext`} valuePropName="checked">
                                                <Switch
                                                    checked={toggleStates[`Anlagen__ANL_Bilder__${entry.id}__PositionGutachtentext`] || false}
                                                    onChange={(checked) => {
                                                        // Update state immediately for visual feedback
                                                        setToggleStates(prev => ({
                                                            ...prev,
                                                            [`Anlagen__ANL_Bilder__${entry.id}__PositionGutachtentext`]: checked
                                                        }));
                                                        // Save immediately
                                                        
                                                        updateDataContent(`Anlagen__ANL_Bilder__${entry.id}__PositionGutachtentext`, checked, dataContentRef.current, "updateByID");
                                                        updateGutachten(dataContentRef.current);
                                                    }}
                                                />
                                                &nbsp;Position im Gutachtentext
                                            </Form.Item>
                                        </div>
                                </Card>
                            ))}
                            {!anlagenCategoryHasDraft(uploadForms, 'ANL_Bilder') && (
                            <div className={`flex  justify-center sacherCenter1 ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Button
                                    className={`${isSwitchOn ? 'auftragBtn1' : 'auftragBtn'}  text-[12px] md:text-[14px] rounded-[30px] m-[20px] button_new_component border-none `}
                                    onClick={() => addCard("ANL_Bilder", true)} id={"button_new_component_Anlagen__ANL_Bilder"}>Neues
                                    Bild</Button>
                            </div>
                            )}

                        </div>
                        <div id="karte" className="scrollable-section border-t border-gray-300">
                            <div
                                className="flex justify-between items-center p-[10px]  md:p-[20px] pr-[3%] md:pr-[10%]">
                                <h3 className={`font-bold text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Karte</h3>

                            </div>

                            {cards.Karte?.map((entry, index) => (
                                <Card className={`pl-[3%] md:pl-[10%] ${isSwitchOn ? 'bgdark' : 'bgwhite'}`}
                                      size="small" key={index}>
                                    <div className={`flex  anlagen ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Form.Item label={`Kategorie`} name={`Anlagen__Karte__${entry.id}__Karte_DDV`}>
                                            <AutoComplete
                                                className={"AutoCompleteTextArea AutoCompleteTextAreaSmall"}
                                                options={enumerationValues.sub_com_Karte_DD?.map(
                                                    (option, index) => ({value: option, key: index})
                                                )}
                                                filterOption={(inputValue, option) =>
                                                    option.value
                                                        .toUpperCase()
                                                        .indexOf(inputValue.toUpperCase()) !== -1
                                                }
                                                onChange={handleSelectChange} // Add your change handler if needed
                                            >
                                                <TextArea
                                                    placeholder="Kategorie"
                                                    autoSize={true}
                                                    className="textInput"
                                                />
                                            </AutoComplete>

                                        </Form.Item>
                                        <div className="ml-[10px] gap-[10px] flex">
                                            <div className=" md:mt-[0] mt-[0]"
                                                 style={{float: 'right', cursor: 'pointer'}}
                                                 onClick={() => deleteCard("Karte", index, entry.id)}>
                                                <RiDeleteBin5Fill className="text-[#FF2E3B] w-[18px] h-[20px]"/>
                                            </div>
                                        </div>
                                    </div>


                                    <Form.Item label="Datei" name={`Anlagen__Karte__${entry.id}__Karte_Doc`}
                                               className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        {uploadForms["Karte"][entry.id] && uploadForms["Karte"][entry.id].visible ? (
                                            <Upload.Dragger customRequest={customUploadFile}
                                                            onChange={(info) => FileChanged(`Anlagen__Karte__${entry.id}__Karte_Doc`, entry.id, "Karte")}
                                                            accept="image/jpg,image/jpeg,image/png">
                                                <p className="ant-upload-drag-icon">
                                                    <UploadOutlined/>
                                                </p>
                                                <p className="ant-upload-text">Klicke oder ziehe Dateien hierhin, um sie
                                                    hochzuladen</p>
                                                <p className="ant-upload-hint">Unterstützte Dateiformate: .jpg, .png</p>
                                            </Upload.Dragger>
                                        ) : uploadForms["Karte"][entry.id] !== undefined ? (
                                            <>
                                                <div className="gap-[10px]">
                                                    <Button icon={<ExportOutlined/>}
                                                            onClick={() => openS3File(uploadForms["Karte"][entry.id].file.url)}>{uploadForms["Karte"][entry.id].file.name}</Button>
                                                    <Button icon={<DeleteOutlined/>}
                                                            onClick={() => handleRemoveAttachment(`Anlagen__Karte__${entry.id}__Karte_Doc`, uploadForms["Karte"][entry.id].file.id)}>
                                                        Löschen
                                                    </Button>
                                                </div>
                                            </>
                                        ) : null}
                                    </Form.Item>
                                    <Form.Item label={"Position:"} name={`Anlagen__Karte__${entry.id}__PositionGutachtentext`} valuePropName="checked"  className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Switch
                                            checked={toggleStates[`Anlagen__Karte__${entry.id}__PositionGutachtentext`] || false}
                                            onChange={(checked) => {
                                                // Update state immediately for visual feedback
                                                setToggleStates(prev => ({
                                                    ...prev,
                                                    [`Anlagen__Karte__${entry.id}__PositionGutachtentext`]: checked
                                                }));
                                                // Save immediately
                                                
                                                updateDataContent(`Anlagen__Karte__${entry.id}__PositionGutachtentext`, checked, dataContentRef.current, "updateByID");
                                                updateGutachten(dataContentRef.current);
                                            }}
                                        />
                                        &nbsp;Position im Gutachtentext
                                    </Form.Item>
                                </Card>
                            ))}
                            {!anlagenCategoryHasDraft(uploadForms, 'Karte') && (
                            <div className={`flex  justify-center sacherCenter1 ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Button
                                    className={`${isSwitchOn ? 'auftragBtn1' : 'auftragBtn'} border-none text-[12px] md:text-[14px] m-[20px] rounded-[30px] border-none1 button_new_component`}
                                    onClick={() => addCard("Karte", true)} id={"button_new_component_Karte"}>Neue
                                    Karte</Button>
                            </div>
                            )}
                        </div>
                        <div id="flurkarte" className="scrollable-section border-t border-gray-300">
                            <div
                                className="flex justify-between items-center p-[10px]  md:p-[20px] pr-[3%] md:pr-[10%]">
                                <h3 className={`font-bold text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Flurkarte</h3>

                            </div>

                            {cards.Flurkarte && Array.isArray(cards?.Flurkarte) && cards.Flurkarte?.map((entry, index) => (
                                <Card className={`pl-[3%] md:pl-[10%] ${isSwitchOn ? 'bgdark' : 'bgwhite'}`}
                                      size="small" key={index}>
                                    <div className={`flex  anlagen ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Form.Item label={`Kategorie`}
                                                   name={`Anlagen__Flurkarte__${entry.id}__Flurkarte_DDV`}>
                                            <AutoComplete
                                                className={"AutoCompleteTextArea AutoCompleteTextAreaSmall"}
                                                options={enumerationValues.sub_com_Flurkarte_DD?.map(
                                                    (option, index) => ({value: option, key: index})
                                                )}
                                                filterOption={(inputValue, option) =>
                                                    option.value
                                                        .toUpperCase()
                                                        .indexOf(inputValue.toUpperCase()) !== -1
                                                }
                                                onChange={handleSelectChange} // Add your change handler if needed
                                            >
                                                <TextArea
                                                    placeholder="Kategorie"
                                                    autoSize={true}
                                                    className="textInput"
                                                />
                                            </AutoComplete>

                                        </Form.Item>
                                        <div className="ml-[10px] gap-[10px] flex">
                                            <div className=" md:mt-[0] mt-[]"
                                                 style={{float: 'right', cursor: 'pointer'}}
                                                 onClick={() => deleteCard("Flurkarte", index, entry.id)}>
                                                <RiDeleteBin5Fill className="text-[#FF2E3B] w-[18px] h-[20px]"/>
                                            </div>
                                        </div>
                                    </div>


                                    <Form.Item label="Datei" name={`Anlagen__Flurkarte__${entry.id}__Flurkarte_Doc`}
                                               className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        {uploadForms["Flurkarte"][entry.id] && uploadForms["Flurkarte"][entry.id].visible ? (
                                            <Upload.Dragger customRequest={customUploadFile}
                                                            onChange={(info) => FileChanged(`Anlagen__Flurkarte__${entry.id}__Flurkarte_Doc`, entry.id, "Flurkarte")}
                                                            accept="image/jpg,image/jpeg,image/png">
                                                <p className="ant-upload-drag-icon">
                                                    <UploadOutlined/>
                                                </p>
                                                <p className="ant-upload-text">Klicke oder ziehe Dateien hierhin, um sie
                                                    hochzuladen</p>
                                                <p className="ant-upload-hint">Unterstützte Dateiformate: .jpg, .png</p>
                                            </Upload.Dragger>
                                        ) : uploadForms["Flurkarte"][entry.id] !== undefined ? (
                                            <>
                                                <div>
                                                    <Button icon={<ExportOutlined/>}
                                                            onClick={() => openS3File(uploadForms["Flurkarte"][entry.id].file.url)}>{uploadForms["Flurkarte"][entry.id].file.name}</Button>
                                                    <Button icon={<DeleteOutlined/>}
                                                            onClick={() => handleRemoveAttachment(`Anlagen__Flurkarte__${entry.id}__Flurkarte_Doc`, uploadForms["Flurkarte"][entry.id].file.id)}>
                                                        Löschen
                                                    </Button>
                                                </div>
                                            </>
                                        ) : null}
                                    </Form.Item>
                                    <Form.Item label={"Position:"} name={`Anlagen__Flurkarte__${entry.id}__PositionGutachtentext`} valuePropName="checked" className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Switch
                                            checked={toggleStates[`Anlagen__Flurkarte__${entry.id}__PositionGutachtentext`] || false}
                                            onChange={(checked) => {
                                                // Update state immediately for visual feedback
                                                setToggleStates(prev => ({
                                                    ...prev,
                                                    [`Anlagen__Flurkarte__${entry.id}__PositionGutachtentext`]: checked
                                                }));
                                                // Save immediately
                                                
                                                updateDataContent(`Anlagen__Flurkarte__${entry.id}__PositionGutachtentext`, checked, dataContentRef.current, "updateByID");
                                                updateGutachten(dataContentRef.current);
                                            }}
                                        />
                                        &nbsp;Position im Gutachtentext
                                    </Form.Item>
                                </Card>
                            ))}
                            {!anlagenCategoryHasDraft(uploadForms, 'Flurkarte') && (
                            <div className={`flex  justify-center sacherCenter1 ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Button
                                    className={`${isSwitchOn ? 'auftragBtn1' : 'auftragBtn'}  text-[12px] md:text-[14px] text-[#FFFFFF] m-[20px] rounded-[30px] border-none button_new_component`}
                                    onClick={() => addCard("Flurkarte", true)} id={"button_new_component_Flurkarte"}>Neue
                                    Flurkarte</Button>
                            </div>
                            )}
                        </div>

                        <div id="grundbuchauszug" className="scrollable-section border-t border-gray-300">
                            <div
                                className="flex justify-between items-center p-[10px]  md:p-[20px] pr-[3%] md:pr-[10%]">
                                <h3 className={`font-bold text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Grundbuchauszug</h3>

                            </div>

                            {cards?.Grundbuchauszug?.map((entry, index) => (
                                <Card className={`pl-[3%] md:pl-[10%] ${isSwitchOn ? 'bgdark' : 'bgwhite'}`}
                                      size="small" key={index}>
                                    <div className={`flex  anlagen ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Form.Item label={`Kategorie`}
                                                   name={`Anlagen__Grundbuchauszug__${entry.id}__GBA_DDV`}>
                                            <AutoComplete
                                                className={"AutoCompleteTextArea AutoCompleteTextAreaSmall"}
                                                options={enumerationValues?.sub_com_GBA_DD?.map(
                                                    (option, index) => ({value: option, key: index})
                                                )}
                                                filterOption={(inputValue, option) =>
                                                    option.value
                                                        .toUpperCase()
                                                        .indexOf(inputValue.toUpperCase()) !== -1
                                                }
                                                onChange={handleSelectChange} // Add your change handler if needed
                                            >
                                                <TextArea
                                                    placeholder="Kategorie"
                                                    autoSize={true}
                                                    className="textInput"
                                                />
                                            </AutoComplete>

                                        </Form.Item>
                                        <div className="ml-[10px] gap-[10px] flex">
                                            <div className=" md:mt-[0] mt-[0]"
                                                 style={{float: 'right', cursor: 'pointer'}}
                                                 onClick={() => deleteCard("Grundbuchauszug", index, entry.id)}>
                                                <RiDeleteBin5Fill className="text-[#FF2E3B] w-[18px] h-[20px]"/>
                                            </div>
                                        </div>
                                    </div>


                                    <Form.Item label="Datei" name={`Anlagen__Grundbuchauszug__${entry.id}__GBA_Doc`}
                                               className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        {uploadForms["Grundbuchauszug"][entry.id] && uploadForms["Grundbuchauszug"][entry.id].visible ? (
                                            <Upload.Dragger customRequest={customUploadFile}
                                                            onChange={(info) => FileChanged(`Anlagen__Grundbuchauszug__${entry.id}__GBA_Doc`, entry.id, "Grundbuchauszug")}
                                                            accept="image/jpg,image/jpeg,image/png">
                                                <p className="ant-upload-drag-icon">
                                                    <UploadOutlined/>
                                                </p>
                                                <p className="ant-upload-text">Klicke oder ziehe Dateien hierhin, um sie
                                                    hochzuladen</p>
                                                <p className="ant-upload-hint">Unterstützte Dateiformate: .jpg, .png</p>
                                            </Upload.Dragger>
                                        ) : uploadForms["Grundbuchauszug"][entry.id] !== undefined ? (
                                            <>
                                                <div>
                                                    <Button icon={<ExportOutlined/>}
                                                            onClick={() => openS3File(uploadForms["Grundbuchauszug"][entry.id].file.url)}>{uploadForms["Grundbuchauszug"][entry.id].file.name}</Button>
                                                    <Button icon={<DeleteOutlined/>}
                                                            onClick={() => handleRemoveAttachment(`Anlagen__Grundbuchauszug__${entry.id}__GBA_Doc`, uploadForms["Grundbuchauszug"][entry.id].file.id)}>
                                                        Löschen
                                                    </Button>
                                                </div>
                                            </>
                                        ) : null}
                                    </Form.Item>
                                    <Form.Item label={"Position:"} name={`Anlagen__Grundbuchauszug__${entry.id}__PositionGutachtentext`} valuePropName="checked" className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Switch
                                            checked={toggleStates[`Anlagen__Grundbuchauszug__${entry.id}__PositionGutachtentext`] || false}
                                            onChange={(checked) => {
                                                // Update state immediately for visual feedback
                                                setToggleStates(prev => ({
                                                    ...prev,
                                                    [`Anlagen__Grundbuchauszug__${entry.id}__PositionGutachtentext`]: checked
                                                }));
                                                // Save immediately
                                                
                                                updateDataContent(`Anlagen__Grundbuchauszug__${entry.id}__PositionGutachtentext`, checked, dataContentRef.current, "updateByID");
                                                updateGutachten(dataContentRef.current);
                                            }}
                                        />
                                        &nbsp;Position im Gutachtentext
                                    </Form.Item>
                                </Card>
                            ))}
                            {!anlagenCategoryHasDraft(uploadForms, 'Grundbuchauszug') && (
                            <div className={`flex  justify-center sacherCenter1 ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Button
                                    className={`${isSwitchOn ? 'auftragBtn1' : 'auftragBtn'}  text-[12px] md:text-[14px] m-[20px] rounded-[30px] border-none button_new_component`}
                                    onClick={() => addCard("Grundbuchauszug", true)}
                                    id={"button_new_component_Grundbuchauszug"}>Neuer Grundbuchauszug</Button>
                            </div>
                            )}
                        </div>
                        <div id="bauplan" className="scrollable-section border-t border-gray-300">
                            <div
                                className="flex justify-between items-center p-[10px]  md:p-[20px] pr-[3%] md:pr-[10%]">
                                <h3 className={`font-bold text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Bauplan</h3>

                            </div>

                            {cards?.Bauplan?.map((entry, index) => (
                                <Card className={`pl-[3%] md:pl-[10%] ${isSwitchOn ? 'bgdark' : 'bgwhite'}`}
                                      size="small" key={index}>
                                    <div className={`flex  anlagen ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Form.Item label={`Kategorie`}
                                                   name={`Anlagen__Bauplan__${entry.id}__Bauplan_DDV`}>
                                            <AutoComplete
                                                className={"AutoCompleteTextArea AutoCompleteTextAreaSmall"}
                                                options={enumerationValues?.sub_com_Bauplan_DD?.map(
                                                    (option, index) => ({value: option, key: index})
                                                )}
                                                filterOption={(inputValue, option) =>
                                                    option.value
                                                        .toUpperCase()
                                                        .indexOf(inputValue.toUpperCase()) !== -1
                                                }
                                                onChange={handleSelectChange} // Add your change handler if needed
                                            >
                                                <TextArea
                                                    placeholder="Kategorie"
                                                    autoSize={true}
                                                    className="textInput"
                                                />
                                            </AutoComplete>

                                        </Form.Item>
                                        <div className="ml-[10px] gap-[10px] flex">
                                            <div className=" md:mt-[0] mt-[0]"
                                                 style={{float: 'right', cursor: 'pointer'}}
                                                 onClick={() => deleteCard("Bauplan", index, entry.id)}>
                                                <RiDeleteBin5Fill className="text-[#FF2E3B] w-[18px] h-[20px]"/>
                                            </div>
                                        </div>
                                    </div>


                                    <Form.Item label="Datei" name={`Anlagen__Bauplan__${entry.id}__Bauplan_Doc`}
                                               className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        {uploadForms["Bauplan"][entry.id] && uploadForms["Bauplan"][entry.id].visible ? (
                                            <Upload.Dragger customRequest={customUploadFile}
                                                            onChange={(info) => FileChanged(`Anlagen__Bauplan__${entry.id}__Bauplan_Doc`, entry.id, "Bauplan")}
                                                            accept="image/jpg,image/jpeg,image/png">
                                                <p className="ant-upload-drag-icon">
                                                    <UploadOutlined/>
                                                </p>
                                                <p className="ant-upload-text">Klicke oder ziehe Dateien hierhin, um sie
                                                    hochzuladen</p>
                                                <p className="ant-upload-hint">Unterstützte Dateiformate: .jpg, .png</p>
                                            </Upload.Dragger>
                                        ) : uploadForms["Bauplan"][entry.id] !== undefined ? (
                                            <>
                                                <div>
                                                    <Button icon={<ExportOutlined/>}
                                                            onClick={() => openS3File(uploadForms["Bauplan"][entry.id].file.url)}>{uploadForms["Bauplan"][entry.id].file.name}</Button>
                                                    <Button icon={<DeleteOutlined/>}
                                                            onClick={() => handleRemoveAttachment(`Anlagen__Bauplan__${entry.id}__Bauplan_Doc`, uploadForms["Bauplan"][entry.id].file.id)}>
                                                        Löschen
                                                    </Button>
                                                </div>
                                            </>
                                        ) : null}
                                    </Form.Item>
                                    <Form.Item label={"Position:"} name={`Anlagen__Bauplan__${entry.id}__PositionGutachtentext`} valuePropName="checked" className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Switch
                                            checked={toggleStates[`Anlagen__Bauplan__${entry.id}__PositionGutachtentext`] || false}
                                            onChange={(checked) => {
                                                // Update state immediately for visual feedback
                                                setToggleStates(prev => ({
                                                    ...prev,
                                                    [`Anlagen__Bauplan__${entry.id}__PositionGutachtentext`]: checked
                                                }));
                                                // Save immediately
                                                
                                                updateDataContent(`Anlagen__Bauplan__${entry.id}__PositionGutachtentext`, checked, dataContentRef.current, "updateByID");
                                                updateGutachten(dataContentRef.current);
                                            }}
                                        />
                                        &nbsp;Position im Gutachtentext
                                    </Form.Item>
                                </Card>
                            ))}
                            {!anlagenCategoryHasDraft(uploadForms, 'Bauplan') && (
                            <div className={`flex  justify-center sacherCenter1 ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Button
                                    className={`${isSwitchOn ? 'auftragBtn1' : 'auftragBtn'}  text-[12px] md:text-[14px] m-[20px] rounded-[30px] border-none button_new_component`}
                                    onClick={() => addCard("Bauplan", true)} id={"button_new_component_Bauplan"}>Neuer
                                    Bauplan</Button>
                            </div>
                            )}
                        </div>
                        <div id="flaechen" className="scrollable-section border-t border-gray-300">
                            <div
                                className="flex justify-between items-center p-[10px]  md:p-[20px] pr-[3%] md:pr-[10%]">
                                <h3 className={`font-bold text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Flächen</h3>

                            </div>

                            {cards?.Flaechen?.map((entry, index) => (
                                <Card className={`pl-[3%] md:pl-[10%] ${isSwitchOn ? 'bgdark' : 'bgwhite'}`}
                                      size="small" key={index}>
                                    <div className={`flex  anlagen ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Form.Item label={`Kategorie`}
                                                   name={`Anlagen__Flaechen__${entry.id}__Flaechen_DDV`}>
                                            <AutoComplete
                                                className={"AutoCompleteTextArea AutoCompleteTextAreaSmall"}
                                                options={enumerationValues?.sub_com_Flaechen_DD?.map(
                                                    (option, index) => ({value: option, key: index})
                                                )}
                                                filterOption={(inputValue, option) =>
                                                    option.value
                                                        .toUpperCase()
                                                        .indexOf(inputValue.toUpperCase()) !== -1
                                                }
                                                onChange={handleSelectChange} // Add your change handler if needed
                                            >
                                                <TextArea
                                                    placeholder="Kategorie"
                                                    autoSize={true}
                                                    className="textInput"
                                                />
                                            </AutoComplete>

                                        </Form.Item>
                                        <div className="ml-[10px] gap-[10px] flex">
                                            <div className=" md:mt-[0] " style={{float: 'right', cursor: 'pointer'}}
                                                 onClick={() => deleteCard("Flaechen", index, entry.id)}>
                                                <DeleteOutlined className="text-[#FF2E3B]"/>
                                            </div>
                                        </div>
                                    </div>


                                    <Form.Item label="Datei" name={`Anlagen__Flaechen__${entry.id}__Flaechen_Doc`}
                                               className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        {uploadForms["Flaechen"][entry.id] && uploadForms["Flaechen"][entry.id].visible ? (
                                            <Upload.Dragger customRequest={customUploadFile}
                                                            onChange={(info) => FileChanged(`Anlagen__Flaechen__${entry.id}__Flaechen_Doc`, entry.id, "Flaechen")}
                                                            accept="image/jpg,image/jpeg,image/png">
                                                <p className="ant-upload-drag-icon">
                                                    <UploadOutlined/>
                                                </p>
                                                <p className="ant-upload-text">Klicke oder ziehe Dateien hierhin, um sie
                                                    hochzuladen</p>
                                                <p className="ant-upload-hint">Unterstützte Dateiformate: .jpg, .png</p>
                                            </Upload.Dragger>
                                        ) : uploadForms["Flaechen"][entry.id] !== undefined ? (
                                            <>
                                                <div>
                                                    <Button icon={<ExportOutlined/>}
                                                            onClick={() => openS3File(uploadForms["Flaechen"][entry.id].file.url)}>{uploadForms["Flaechen"][entry.id].file.name}</Button>
                                                    <Button icon={<DeleteOutlined/>}
                                                            onClick={() => handleRemoveAttachment(`Anlagen__Flaechen__${entry.id}__Flaechen_Doc`, uploadForms["Flaechen"][entry.id].file.id)}>
                                                        Löschen
                                                    </Button>
                                                </div>
                                            </>
                                        ) : null}
                                    </Form.Item>
                                    <Form.Item label={"Position:"} name={`Anlagen__Flaechen__${entry.id}__PositionGutachtentext`} valuePropName="checked" className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Switch
                                            checked={toggleStates[`Anlagen__Flaechen__${entry.id}__PositionGutachtentext`] || false}
                                            onChange={(checked) => {
                                                // Update state immediately for visual feedback
                                                setToggleStates(prev => ({
                                                    ...prev,
                                                    [`Anlagen__Flaechen__${entry.id}__PositionGutachtentext`]: checked
                                                }));
                                                // Save immediately
                                                
                                                updateDataContent(`Anlagen__Flaechen__${entry.id}__PositionGutachtentext`, checked, dataContentRef.current, "updateByID");
                                                updateGutachten(dataContentRef.current);
                                            }}
                                        />
                                        &nbsp;Position im Gutachtentext
                                    </Form.Item>
                                </Card>
                            ))}
                            {!anlagenCategoryHasDraft(uploadForms, 'Flaechen') && (
                            <div className={`flex  justify-center sacherCenter1 ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Button
                                    className={`${isSwitchOn ? 'auftragBtn1' : 'auftragBtn'}  text-[12px] md:text-[14px] m-[20px] rounded-[30px] border-none button_new_component`}
                                    onClick={() => addCard("Flaechen", true)} id={"button_new_component_Flaechen"}>Neue
                                    Flächendatei</Button>
                            </div>
                            )}
                        </div>
                        <div id="sonstige-anlagen" className="scrollable-section border-t border-gray-300">
                            <div
                                className="flex justify-between items-center p-[10px]  md:p-[20px] pr-[3%] md:pr-[10%]">
                                <h3 className={`font-bold text-[20px] generalText ${isSwitchOn ? 'text-white' : 'text-black'}`}>Sonstige
                                    Anlagen</h3>

                            </div>

                            {cards?.SonstigeAnlagen?.map((entry, index) => (
                                <Card className={`pl-[3%] md:pl-[10%] ${isSwitchOn ? 'bgdark' : 'bgwhite'}`}
                                      size="small" key={index}>
                                    <div className={`flex  anlagen ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Form.Item label={`Kategorie`}
                                                   name={`Anlagen__SonstigeAnlagen__${entry.id}__SonstAnl_DDV`}>
                                            <AutoComplete
                                                className={"AutoCompleteTextArea AutoCompleteTextAreaSmall"}
                                                options={enumerationValues?.sub_com_SonstAnl_DD?.map(
                                                    (option, index) => ({value: option, key: index})
                                                )}
                                                filterOption={(inputValue, option) =>
                                                    option.value
                                                        .toUpperCase()
                                                        .indexOf(inputValue.toUpperCase()) !== -1
                                                }
                                                onChange={handleSelectChange} // Add your change handler if needed
                                            >
                                                <TextArea
                                                    placeholder="Kategorie"
                                                    autoSize={true}
                                                    className="textInput"
                                                />
                                            </AutoComplete>

                                        </Form.Item>
                                        <div className="ml-[10px] gap-[10px] flex">
                                            <div className=" md:mt-[0] mt-[0]"
                                                 style={{float: 'right', cursor: 'pointer'}}
                                                 onClick={() => deleteCard("SonstigeAnlagen", index, entry.id)}>
                                                <RiDeleteBin5Fill className="text-[#FF2E3B] w-[18px] h-[20px]"/>
                                            </div>
                                        </div>
                                    </div>


                                    <Form.Item label="Datei"
                                               name={`Anlagen__SonstigeAnlagen__${entry.id}__SonstAnl_Doc`}
                                               className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        {uploadForms["SonstigeAnlagen"][entry.id] && uploadForms["SonstigeAnlagen"][entry.id].visible ? (
                                            <Upload.Dragger customRequest={customUploadFile}
                                                            onChange={(info) => FileChanged(`Anlagen__SonstigeAnlagen__${entry.id}__SonstAnl_Doc`, entry.id, "SonstigeAnlagen")}
                                                            accept="image/jpg,image/jpeg,image/png">
                                                <p className="ant-upload-drag-icon">
                                                    <UploadOutlined/>
                                                </p>
                                                <p className="ant-upload-text">Klicke oder ziehe Dateien hierhin, um sie
                                                    hochzuladen</p>
                                                <p className="ant-upload-hint">Unterstützte Dateiformate: .jpg, .png</p>
                                            </Upload.Dragger>
                                        ) : uploadForms["SonstigeAnlagen"][entry.id] !== undefined ? (
                                            <>
                                                <div>
                                                    <Button icon={<ExportOutlined/>}
                                                            onClick={() => openS3File(uploadForms["SonstigeAnlagen"][entry.id].file.url)}>{uploadForms["SonstigeAnlagen"][entry.id].file.name}</Button>
                                                    <Button icon={<DeleteOutlined/>}
                                                            onClick={() => handleRemoveAttachment(`Anlagen__SonstigeAnlagen__${entry.id}__SonstAnl_Doc`, uploadForms["SonstigeAnlagen"][entry.id].file.id)}>
                                                        Löschen
                                                    </Button>
                                                </div>
                                            </>
                                        ) : null}
                                    </Form.Item>
                                    <Form.Item label={"Position:"} name={`Anlagen__SonstigeAnlagen__${entry.id}__PositionGutachtentext`} valuePropName="checked" className={`max-content4 ${isSwitchOn ? 'maxColor' : ''}`}>
                                        <Switch
                                            checked={toggleStates[`Anlagen__SonstigeAnlagen__${entry.id}__PositionGutachtentext`] || false}
                                            onChange={(checked) => {
                                                // Update state immediately for visual feedback
                                                setToggleStates(prev => ({
                                                    ...prev,
                                                    [`Anlagen__SonstigeAnlagen__${entry.id}__PositionGutachtentext`]: checked
                                                }));
                                                // Save immediately
                                                
                                                updateDataContent(`Anlagen__SonstigeAnlagen__${entry.id}__PositionGutachtentext`, checked, dataContentRef.current, "updateByID");
                                                updateGutachten(dataContentRef.current);
                                            }}
                                        />
                                        &nbsp;Position im Gutachtentext
                                    </Form.Item>
                                </Card>
                            ))}
                            {!anlagenCategoryHasDraft(uploadForms, 'SonstigeAnlagen') && (
                            <div className={`flex  justify-center sacherCenter1 ${isSwitchOn ? 'maxColor' : ''}`}>
                                <Button
                                    className={`${isSwitchOn ? 'auftragBtn1' : 'auftragBtn'}  text-[12px] md:text-[14px] m-[20px] rounded-[30px] border-none button_new_component`}
                                    onClick={() => addCard("SonstigeAnlagen", true)}
                                    id={"button_new_component_SonstigeAnlagen"}>Neue sonstige Anlage</Button>
                            </div>
                            )}
                        </div>
                    </Form>
                )}
            </div>
        </div>
    );
};

const Anlagen = () => (
    <GutachtenShell menuLinks={MENU_LINKS}>
        <FormContainer />
    </GutachtenShell>
);

export default Anlagen;
